/*
 * Copyright 2025 Larder Software Limited
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { useApi } from '@backstage/core-plugin-api';
import { useAsync } from 'react-use';
import { GithubSearchPullRequestsDataItem } from '../types';
import { githubPullRequestsApiRef } from '../api';

export const useGithubSearchPullRequest = (
  query: string,
  hostname?: string,
) => {
  const githubPrsApi = useApi(githubPullRequestsApiRef);

  return useAsync(async (): Promise<GithubSearchPullRequestsDataItem[]> => {
    return await githubPrsApi.searchPullRequest({ query, hostname });
  }, [githubPrsApi]);
};
